"use client";

import { usePathname } from "next/navigation";

type SiteFooterGateProps = {
  children: React.ReactNode;
};

// /quiz and /quiz/results/* are app-like layouts built on the assumption that
// nothing renders below <main>: the results action bar is fixed to the
// viewport bottom below lg: (see actionBarSpacing.ts) and PhotoSplit sizes
// each quiz step to exactly the viewport height. A footer there either sits
// hidden behind the action bar or forces the page to overflow, so it's
// suppressed on those routes rather than shown everywhere.
export function SiteFooterGate({ children }: SiteFooterGateProps) {
  const pathname = usePathname();
  if (pathname === "/quiz" || pathname.startsWith("/quiz/")) return null;
  return <>{children}</>;
}
